//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { useCurrentStateAndParams } from '@hooks/useCurrentStateAndParams';
import { ICuralateStore } from '@models/AppState';
import { useModeratorSurface } from '@moderation-mode/hooks/useModeratorSurface';
import { MODERATOR_DEFAULT_STATE } from '@moderation-mode/moderationModeRouteAccess';
import {
  getHasModeratorUiaWritePermission,
  getIsModeratorUiaEnabled,
} from '@moderation-mode/moderationModeDerivation';

export const useModeratorUiaAccess = () => {
  const session = useSelector(
    (state: ICuralateStore) => state.session,
  );
  const { isModeratorSurface } = useModeratorSurface();
  const { state } = useCurrentStateAndParams();

  const isModeratorUiaEnabled = getIsModeratorUiaEnabled(
    session,
    isModeratorSurface,
  );

  const hasModeratorWritePermission =
    getHasModeratorUiaWritePermission(session);

  const isShareFlowEnabled =
    isModeratorUiaEnabled && state !== MODERATOR_DEFAULT_STATE;

  return {
    isModeratorUiaEnabled,
    hasModeratorWritePermission,
    isShareFlowEnabled,
    canShareModerationMedia:
      isShareFlowEnabled && hasModeratorWritePermission,
  };
};
